// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-bYjOz","size_default":"size_default-epQ_B","size_small":"size_small-qcOe1","size_large":"size_large-G3unu","blank":"blank-Wtdtf"};